export const getFormElementsFromFormConfig = completeFormModel => completeFormModel.extraSettings.sections.reduce(
	(runningFormElements, section) => [ ...runningFormElements, ...extractQuestionsFromSection(section) ],
	[],
);


export const extractQuestionsFromSection = section => {
	const questions = [];
	for (const row of section.extraSettings.layoutDefinition.rows) {
		for (const question of row.cols) {
			questions.push({
				id: question.id,
				value: question.value,
				label: question.label,
				type: question.type,
				cayuseType: question.cayuseType,
				section: section.label,
				columnHeader: question.cayuseShortLabel,
				answer: null,
				items: question.extraSettings?.items,
				dataSource: {
					type: question.extraSettings?.dataSource,
					staticValues: null,
					restQueryUrl: question.extraSettings?.queryUrl,
					restLookupUrl: question.extraSettings?.lookupUrl,
					restFormatItem: question.extraSettings?.formatItem,
					restIdentity: question.extraSettings?.storage,
				},
				extraSettings: question.extraSettings
			});
		}
	}

	return questions;
};
